<div class="container single-view" id="view-market">
  <div class="row">
    <div class="col-12 mb-4 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" href="javascript:void(0)" appBack fallbackUrl="/markets"
          class="inline-flex items-center text-base link link-icon left-arrow">{{
          'MARKETS.BTN_BACK_TO_MARKET' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-baseline justify-between gap-4">
        <div class="title-wr flex flex-wrap items-center">
          <div data-testid="market-item">
            <h1 data-testid="section-item" class="section-title mb-3">{{ 'MARKET_SINGLE_VIEW.MARKET_DETAILS' | translate }}</h1>
            <div>
              <h2 data-testid="element-item" class="element-title flex items-center gap-2">
                @if (market.name) {
                  <span data-testid='market-name'>{{ market.name | defaultValue }}</span>
                }
              </h2>
            </div>
          </div>
        </div>
        <div class="flex flex-wrap justify-between gap-y-4 self-end">
          <div id="complementary-details" class="flex flex-wrap"></div>
          <div id="actions-wr" class="flex flex-wrap items-stretch justify-end gap-3">

            @if (allowManageRetailers) {
              <button data-testid="market-manageretailers-btn" class="btn outline-btn" (click)="manageMarketRetailers()"> {{ 'MARKET_SINGLE_VIEW.BTN_MANAGE_RETAILERS' | translate }}</button>
            }

            @if (allowManageUsers) {
              <button data-testid="market-manageusers-btn" class="btn outline-btn" (click)="manageMarketUsers()">{{ 'MARKET_SINGLE_VIEW.BTN_ADD_USERS' | translate }}
              </button>
            }

            @if (allowModifyMarket) {
              <button data-testid="market-edit-btn" id="btn-edit-market" class="btn primary-btn" (click)="goToEditMarket()">{{ 'MARKET_SINGLE_VIEW.BTN_EDIT' | translate }}</button>
            }

            @if (delete) {
              <button data-testid="market-delete-btn" class="btn red-btn" (click)="showDeleteDialog()">{{'MARKETS.BTN_DELETE' | translate }}</button>
            }
          </div>
        </div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-4 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <section class="row">
              <div class="col-12">
                <h4 data-testid="market-details">{{ 'MARKET_SINGLE_VIEW.DETAILS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
                <dl class="details-grid">
                  <dt data-testid="market-name-label" class="label grid-cols-1 pt-3">{{ 'MARKET_SINGLE_VIEW.NAME' | translate }}</dt>
                  <dd data-testid="market-name" class="value pt-3 pb-3">{{ market.name | defaultValue }}</dd>

                  <dt data-testid="market-code-label" class="label grid-cols-1 pt-3">{{ 'MARKET_SINGLE_VIEW.CODE' | translate }}</dt>
                  <dd data-testid="market-code" class="value pt-3 pb-3">{{ market.code | defaultValue }}</dd>

                  <dt data-testid="market-warrantyduration-label" class="label grid-cols-1 pt-3">{{ 'MARKET_SINGLE_VIEW.WARRANTY_DEFAULT_DURATION' | translate }}</dt>
                  <dd data-testid="market-warrantyduration" class="value pt-3 pb-3">
                    <span pTooltip="{{ market.warrantyDurationMonths }} {{ 'MARKET_SINGLE_VIEW.MONTHS' | translate }}" tooltipPosition="top">
                      {{ market.warrantyDurationMonths | dateConversion | defaultValue }}
                    </span>
                  </dd>

                  <dt data-testid="market-hasparent-label" class="label grid-cols-1 pt-3">{{ 'MARKET_SINGLE_VIEW.HAS_PARENT' | translate }}</dt>
                  <dd data-testid="market-hasparent" class="value pt-3 pb-3">{{ (market.parent ? 'BOOLEANS.YES' : 'BOOLEANS.NO') | translate }}</dd>

                  @if (market.parent) {
                    <dt data-testid="market-parentmarket-label" class="label grid-cols-1 pt-3">{{ 'MARKET_SINGLE_VIEW.PARENT_NAME' | translate }}</dt>
                    <dd class="value pt-3 pb-3">
                      @if (market.parent.id) {
                        <a [routerLink]="['/markets/', market.parent.id]" class="inline-flex items-center link">
                          {{ market.parent.name }}
                        </a>
                      } @else {
                        {{ market.parent.name | defaultValue }}
                      }
                    </dd>

                    <dt data-testid="market-parentcode-label" class="label grid-cols-1 pt-3">
                      {{ 'MARKET_SINGLE_VIEW.PARENT_CODE' | translate }}
                    </dt>
                    <dd data-testid="market-parentcode" class="value pt-3 pb-3">
                      {{ market.parent.code | defaultValue }}
                    </dd>
                  }
                </dl>
              </div>
            </section>
            <!-- /main content -->

            <section class="row">
              <div class="col-12 mb-3">
                <h4 data-testid="market-retailers-details">{{ 'MARKET_SINGLE_VIEW.MARKET_RETAILERS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>

              <div class="col-12">
                <p-table data-testid="market-retailers" [value]="market.retailers ?? []">

                  <ng-template pTemplate="header">
                    <tr>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">
                            {{ 'MARKET_SINGLE_VIEW.CODE' | translate }}
                          </span>
                        </div>
                      </th>

                      <th>
                        <div class="header-wr">
                          <span class="col-name">
                            {{ 'MARKET_SINGLE_VIEW.NAME' | translate }}
                          </span>
                        </div>
                      </th>

                      <th>
                        <div class="header-wr">
                          <span class="col-name">
                            {{ 'MARKET_SINGLE_VIEW.STATUS' | translate }}
                          </span>
                        </div>
                      </th>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="body" let-marketRetailer>
                    <tr>
                      <td>
                        <span class="p-column-title">
                          {{ 'MARKET_SINGLE_VIEW.CODE' | translate }}:
                        </span>
                        {{ marketRetailer.code | defaultValue }}
                      </td>

                      <td>
                        <span class="p-column-title">
                          {{ 'MARKET_SINGLE_VIEW.NAME' | translate }}:
                        </span>

                        <a [routerLink]="['/retailers', marketRetailer.id]" class="inline-flex items-center link">
                          {{ marketRetailer.name | defaultValue }}
                        </a>
                      </td>

                      <td>
                        <span class="p-column-title">{{ 'MARKET_SINGLE_VIEW.STATUS' | translate }}:</span>

                        @if (marketRetailer.isActive) {
                          <span class="tag tag-green">
                            {{ 'BOOLEANS.ACTIVE' | translate }}
                          </span>
                          } @else {
                          <span class="tag tag-red">
                            {{ 'BOOLEANS.INACTIVE' | translate }}
                          </span>
                        }
                      </td>
                    </tr>
                  </ng-template>

                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="3">{{ 'MARKET_SINGLE_VIEW.NO_DATA' | translate }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>

            <section class="row">
              <div class="col-12 mb-3">
                <h4 data-testid="market-users-details">{{ 'MARKET_SINGLE_VIEW.MARKET_USERS' | translate }}</h4>
                <hr role="presentation" class="w-full mb-2 mt-3 border-t">
              </div>

              <div class="col-12">
                <p-table data-testid="market-users" [value]="marketUsersData">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>
                        <div class="header-wr">
                          {{ 'MARKET_SINGLE_VIEW.FIRST_NAME' | translate }}
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">
                            {{ 'MARKET_SINGLE_VIEW.LAST_NAME' | translate }}
                          </span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">
                            {{ 'MARKET_SINGLE_VIEW.USERNAME' | translate }}
                          </span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">
                            {{ 'MARKET_SINGLE_VIEW.EMAIL' | translate }}
                          </span>
                        </div>
                      </th>
                      <th>
                        <div class="header-wr">
                          <span class="col-name">
                            {{ 'MARKET_SINGLE_VIEW.STATUS' | translate }}
                          </span>
                        </div>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-marketUser>
                    <tr>
                      <td>
                        <span class="p-column-title">
                          {{ 'MARKET_SINGLE_VIEW.FIRST_NAME' | translate }}:
                        </span>
                        {{ marketUser.firstName | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">
                          {{ 'MARKET_SINGLE_VIEW.LAST_NAME' | translate }}:
                        </span>
                        {{ marketUser.lastName | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">
                          {{ 'MARKET_SINGLE_VIEW.USERNAME' | translate }}:
                        </span>

                        @if (marketUser?.id) {
                          <a [routerLink]="['/users/', marketUser.id]" class="inline-flex items-center link">{{ marketUser.username }}</a>
                        } @else {
                          {{ marketUser.username | defaultValue }}
                        }
                      </td>
                      <td>
                        <span class="p-column-title">
                          {{ 'MARKET_SINGLE_VIEW.EMAIL' | translate }}:
                        </span>
                        {{ marketUser.email | defaultValue }}
                      </td>
                      <td>
                        <span class="p-column-title">
                          {{ 'MARKET_SINGLE_VIEW.STATUS' | translate }}:
                        </span>

                        @if (marketUser.isActive) {
                          <span class="tag tag-green">{{ marketUser.status ?? ('BOOLEANS.ACTIVE' | translate) }}</span>
                        } @else {
                          <span class="tag tag-red">{{ marketUser.status ?? ('BOOLEANS.INACTIVE' | translate) }}</span>
                        }
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="6">
                        {{ 'MARKET_SINGLE_VIEW.NO_DATA' | translate }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </section>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Delete market -->
<dialog-reason #dialog [title]="'MODALBOXES.TITLE_CONFIRM_DELETE_MARKET'" (onClose)="deleteMarket($event)"></dialog-reason>
